import React from "react";

import { Props } from "./type";
import styles from "./styles.scss";

function NameWithCount(props: Props) {
  return (
    <div className={styles.nameWithCount}>
      {props.icon}
      <p className={styles.name}>{props.name}</p>
    </div>
  );
}

export { NameWithCount };
